import { render, staticRenderFns } from "./Subjects.vue?vue&type=template&id=26dce886&scoped=true&"
import script from "./Subjects.ts?vue&type=script&lang=ts&"
export * from "./Subjects.ts?vue&type=script&lang=ts&"
import style0 from "./Subjects.vue?vue&type=style&index=0&id=26dce886&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26dce886",
  null
  
)

export default component.exports